import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { SectionHeader } from './SectionHeader';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el kit después de comprar?',
  a: 'El acceso es inmediato. Apenas se confirma el pago por Mercado Pago, recibís un mail automático con el link para descargar todos los PDFs (los 8 tomos y los 3 bonos) a tu computadora, tablet o celular.'
}, {
  q: '¿Sirve si recién egresé o necesito tener más experiencia?',
  a: 'Está diseñado exactamente para vos. El kit puentea la brecha entre la teoría de la facultad y la práctica real del consultorio. Te da la estructura y seguridad que los años de experiencia te darían, pero desde tu primer paciente.'
}, {
  q: '¿Las plantillas son editables o solo las puedo leer?',
  a: 'Las plantillas clave (como la ficha de anamnesis, los modelos de informes y el registro de seguimiento) vienen listas para imprimir o para que las uses como base y las adaptes a tu propio estilo.'
}, {
  q: '¿Los 3 bonos están incluidos en las dos ofertas?',
  a: 'Sí, absolutamente. Tanto si elegís el Kit Esencial como la Edición Completa, te llevás los 3 bonos de regalo (Tabla de hitos, Guía de respuestas y Plantilla de seguimiento).'
}, {
  q: '¿Sirve si trabajo en una clínica además del consultorio privado?',
  a: 'Totalmente. Los protocolos de evaluación, anamnesis e informes (Tomos 1 al 6) son universales y elevarán tu profesionalismo en cualquier ámbito clínico donde atiendas niños.'
}, {
  q: '¿Sirve si atiendo adultos además de niños?',
  a: 'El kit está 100% enfocado en población infantil y pediátrica. Los tests, hitos del desarrollo y protocolos de anamnesis están pensados para el abordaje con niños y sus familias.'
}, {
  q: '¿Qué diferencia tiene con los apuntes de la facultad?',
  a: 'La facultad te enseña la patología y la teoría del test. Este kit te enseña la clínica real: qué decir cuando el nene llora, cómo redactar el informe rápido, cómo elegir el test en 5 minutos y cómo cobrar lo que corresponde.'
}, {
  q: '¿Por qué elegir la Edición Completa y no el Kit Esencial?',
  a: 'Porque saber evaluar es solo la mitad del trabajo. La Edición Completa te resuelve la otra mitad: cómo gestionar el consultorio para que sea rentable (honorarios, cancelaciones) y cómo conseguir pacientes sin depender de obras sociales.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí, 100% real. Tenés 7 días desde la compra. Si sentís que el material no te sirve para tu práctica clínica, nos mandás un mail y te reintegramos el dinero por Mercado Pago el mismo día. Sin vueltas.'
}];
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-12 md:py-20 px-4 md:px-8 bg-white" data-id="element-96">
      <div className="max-w-3xl mx-auto" data-id="element-97">
        <SectionHeader eyebrow="DUDAS COMUNES" title="PREGUNTAS FRECUENTES" className="mb-8 md:mb-12" data-id="element-98" />

        <div className="space-y-2 md:space-y-4" data-id="element-99">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className="border-b border-slate-200 last:border-0 pb-2 md:pb-4" data-id="element-100">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full text-left py-3 md:py-4 flex items-center justify-between gap-3 md:gap-4 focus:outline-none group" data-id="element-101">
                  <h3 className="font-bold text-teal-900 group-hover:text-teal-700 transition-colors text-base md:text-lg pr-4 md:pr-8 leading-tight" data-id="element-102">
                    {faq.q}
                  </h3>
                  <div className={`shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180 text-terracotta' : 'text-slate-400'}`} data-id="element-103">
                    <ChevronDownIcon size={20} data-id="element-104" />
                  </div>
                </button>

                <AnimatePresence data-id="element-105">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" data-id="element-106">
                      <p className="text-sm md:text-base text-slate-600 pb-3 md:pb-4 leading-relaxed" data-id="element-107">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}